<template>
  <div id="app">
    <div
      class="homeFour"
      :style="homeFourStyle"
    >
      <messageDiv v-if="!loginShow && userInfo.hospital&&userInfo.hospital.length" />
      <loginBut :user-info=" userInfo " />
      <loginDiv v-if="loginShow" @finish="finishLogin" @choose="chooseHospital" />
      <myCenter v-if="showMyCenter" ref="myCenter" :user-info="userInfo" @closeCenter="showMyCenter=false" @logout="logout" @modify="modifyInfo" />

      <div v-if="userInfo.hospital&&userInfo.hospital.length>1" class="tools" @click="switchHospital">
        <div>
        </div>
          <span class="toolsText">切换</span>
      </div>
      <!-- <div class="homeFive1Con" :style="homeFive1ConStyle" @click="goMansion(1,'ksxt')">
        <div class="homeFive1" :style="homeFive1Style">
          <div class="homeFive1Clip"></div>
        </div>
        <mansionInfo :status="(system_role.filter(item => item.system === 'ksxt')[0] || {}).status || ''" :infoCon="homeFive1InfoCon" :style="homeFive1MansionInfoStyle"></mansionInfo>
      </div> -->
      <div class="homeFour1Con" :style="homeFour1ConStyle" @click="goMansion(1,'ksxt')">
        <div class="homeFour1" :style="homeFour1Style">
          <div class="homeFour1Clip"></div>
        </div>
        <mansionInfo
           :status="(system_role.filter(item => item.system === 'ksxt')[0] || {}).status || ''"
           :infoCon="homeFour1InfoCon" :style="homeFour1MansionInfoStyle"></mansionInfo>
      </div>
      <!-- <div class="homeFive2Con" v-if="system_role && system_role.length > 1" :style="homeFive2ConStyle" @click="goMansion(2,'thinking_training_system')">
        <div class="homeFive2" :style="homeFive2Style">
          <div class="homeFive2Clip"></div>
        </div>
        <mansionInfo
          :status="(system_role.filter(item => item.system === 'thinking_training_system')[0] || {}).status || ''"
          :infoCon="homeFive2InfoCon" :style="homeFive2MansionInfoStyle"
        ></mansionInfo>
      </div> -->
       <div v-if="system_role && system_role.some(item => item.system === 'thinking_training_system')" class="homeFour2Con" :style="homeFour2ConStyle" @click="goMansion(2,'thinking_training_system')">
        <div class="homeFour2" :style="homeFour2Style">
          <div class="homeFour2Clip"></div>
        </div>
        <mansionInfo 
          :status="(system_role.filter(item => item.system === 'thinking_training_system')[0] || {}).status || ''"
          :infoCon="homeFour2InfoCon" :style="homeFour2MansionInfoStyle"></mansionInfo>
      </div>
      <!-- <div class="homeFive3Con" v-if="system_role && system_role.length > 1" :style="homeFive3ConStyle" @click="goMansion(3,'skill_practice_system')">
        <div class="homeFive3" :style="homeFive3Style">
          <div class="homeFive3Clip"></div>
        </div>
        <mansionInfo 
          :status="(system_role.filter(item => item.system === 'skill_practice_system')[0] || {}).status || ''"
          :infoCon="homeFive3InfoCon" :style="homeFive3MansionInfoStyle"
        ></mansionInfo>
      </div> -->
      <div v-if="system_role && system_role.some(item => item.system === 'skill_practice_system')" class="homeFour3Con" :style="homeFour3ConStyle" @click="goMansion(3,'skill_practice_system')">
        <div class="homeFour3" :style="homeFour3Style">
          <div class="homeFour3Clip"></div>
        </div>
        <mansionInfo 
          :status="(system_role.filter(item => item.system === 'skill_practice_system')[0] || {}).status || ''"
          :infoCon="homeFour3InfoCon" :style="homeFour3MansionInfoStyle"></mansionInfo>
      </div>

      <!-- <div class="homeFive4Con" v-if="system_role && system_role.length > 1" :style="homeFive4ConStyle" @click="goMansion(4,'skill_practice_system')">
        <div class="homeFive4" :style="homeFive4Style">
          <div class="homeFive4Clip"></div>
        </div>
        <mansionInfo
          :status="(system_role.filter(item => item.system === 'skill_practice_system')[0] || {}).status || ''"
          :infoCon="homeFive4InfoCon" :style="homeFive4MansionInfoStyle"
        ></mansionInfo>
      </div> -->

      <div v-if="system_role && system_role.some(item => item.system === 'shengyun_exam_system')" class="homeFour4Con" :style="homeFour4ConStyle" @click="goMansion(4,'shengyun_exam_system')">
        <div class="homeFour4" :style="homeFour4Style">
          <div class="homeFour4Clip"></div>
        </div>
        <mansionInfo
          :status="(system_role.filter(item => item.system === 'shengyun_exam_system')[0] || {}).status || ''"
          :infoCon="homeFour4InfoCon" :style="homeFour4MansionInfoStyle"></mansionInfo>
      </div>
    </div>

    <changeHospital
      :show-hospital="showHospital"
      :hospital-data="hospitalData"
      @update:showHospital="changeHospitalId"
      @saveId="saveId"
    />
    <modifyInfo :modify-obj="modifyObj" @update:modifyObj="modifyUpdate" @updateInfo="updateInfo" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getScaleNum, getPolygon } from "@/utils/index.js"
import { getInfo, userHospital, shengyuRegisterOrLogin } from '@/http/index'
import mansionInfo from '../../components/MansionInfo/index.vue'
import messageDiv from './child/message.vue'
import userDiv from './child/user.vue'
import loginDiv from './child/login.vue'
import loginBut from './child/loginBut.vue'
import changeHospital from '../login/child/change.vue'
import  myCenter from './child/myCenter.vue'
import modifyInfo from '../personal/child/modify.vue'
export default {
  components: { mansionInfo, messageDiv, userDiv, loginDiv, loginBut, changeHospital, myCenter, modifyInfo },
  data() {
    return {
      modifyObj: {
        modifyVisible: false,
        type: null
      },
      showMyCenter: false,
      showHospital: false,
      hospitalData: [],
      chooseInfo: {},
      loginShow: false,
      sysMessageShow: false,
      hospital_id: localStorage.getItem('hospital_id'),
      system_role: [],
      homeFourStyle:{
        width:"1920px",
        height:"1080px",

      },
      homeFour1ConStyle:{
        top:"383px",
        left:"1204px",
        width:"517px",
        height:"413px",
      },
      homeFour1Style:{
        clipPath:"",
      },
      homeFour2ConStyle:{
        top:"339px",
        left:"722px",
        width:"499px",
        height:"233px",
      },
      homeFour2Style:{
        clipPath:"",
      },
      homeFour3ConStyle:{
        top:"310px",
        left:"276px",
        width:"435px",
        height:"170px",
      },
      homeFour3Style:{
        clipPath:"",
      },
      homeFour4ConStyle:{
        top:"577px",
        left:"475px",
        width:"435px",
        height:"239px",
      },
      homeFour4Style:{
        clipPath:"",
      },
      homeFour1MansionInfoStyle:{
        transform: "scale(1)"
      },
      homeFour2MansionInfoStyle:{
        transform: "scale(1)"
      },
      homeFour3MansionInfoStyle:{
        transform: "scale(1)"
      },
      homeFour4MansionInfoStyle:{
        transform: "scale(1)"
      },
      homeFour1InfoCon: {
        "id": 42,
        "organId": 136,
        "constructName": "医学考试系统(理论)",
        "introduction": "医学考试系统(理论)",
        "constructNumber": "",
        "moduleValues": "3",
        "moduleValueName": "医学考试系统(理论)",
        "routerUrl": "123",
        "isClosed": 0,
        "status": 0
      },
      homeFour2InfoCon: {
        "id": 41,
        "organId": 136,
        "constructName": "思维训练系统",
        "introduction": "思维训练系统",
        "constructNumber": "",
        "moduleValues": "1",
        "moduleValueName": "思维训练系统",
        "routerUrl": "123",
        "isClosed": 1,
        "status": 0
      },
      homeFour3InfoCon: {
        "id": 41,
        "organId": 136,
        "constructName": "技能实操系统",
        "introduction": "技能实操系统",
        "constructNumber": "",
        "moduleValues": "1",
        "moduleValueName": "技能实操系统",
        "routerUrl": "123",
        "isClosed": 1,
        "status": 0
      },
      homeFour4InfoCon:{
        "id": 41,
        "organId": 136,
        "constructName": "考试中心(思维+技能)",
        "introduction": "考试中心(思维+技能)",
        "constructNumber": "",
        "moduleValues": "1",
        "moduleValueName": "考试中心(思维+技能)",
        "routerUrl": "123",
        "isClosed": 1
      },
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.loginShow = !localStorage.getItem('token')
    if (this.loginShow) {
      this.system_role = []
    } else {
      if(localStorage.getItem('hospital_id')){
        this.getRole()
      }else{
        this.system_role = [{
          "system": "ksxt",
          "expire_at": "2027-10-31 00:00:00",
          "status": 1
        }]
      }
    }
  },

  mounted() {
    this.initStyle();
    window.addEventListener('resize', () => {
      this.initStyle()
    })
  },
  methods: {
    async getRole() {
      const res = await userHospital({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      });
      if (res.code === 200) {
        const hospital = res.data;
        this.system_role =  hospital.find(item => item.id == this.hospital_id).system_role;
      }
    },
    modifyInfo(data) {
      this.modifyObj = data
    },
    modifyUpdate() {
      this.modifyObj = {
        type: null,
        modifyVisible: false
      }
      this.$refs.myCenter.getUserInfo()
    },
    updateInfo() {
      this.modifyObj = {
        type: null,
        modifyVisible: false
      }
    },
    goShowMyCenter(val) {
      this.showMyCenter = val;
    },
    logout() {
      this.$store.dispatch('loginOut').then(res => {
        // this.$router.push('/')
        this.showMyCenter = false
        this.loginShow = true
      })
    },
    changeHospitalId() {
      this.hospitalData = [];
      this.showHospital = false
    },
    async saveId(id) {
      localStorage.setItem('hospital_id', id)
      this.hospital_id = id
      if (!this.loginShow) {
        this.$message.success('切换成功')
        this.showHospital = false;
        this.$router.push('/')
        this.getRole();
      } else {
        const res = await getInfo({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        })
        if (res.code === 200) {
          this.$store.commit('editUserInfo', res.data);
          this.showHospital = false;
          this.$message.success('登录成功')
          this.loginShow = false;
          this.system_role = res.data.hospital.find(item => item.id == res.data.hospital_id).system_role
        }
      }
    },
    chooseHospital(data) {
      this.chooseInfo = data;
      this.hospitalData = data.hospital;
      this.showHospital = true;
    },
    finishLogin(id) {
      if(id){
        this.hospital_id = id
        this.loginShow = false;
        this.system_role = this.userInfo.hospital.find(item => item.id == this.hospital_id).system_role
      }else{
        this.hospital_id = null
        this.loginShow = false;
        this.system_role = [{
          "system": "ksxt",
          "expire_at": "2027-10-31 00:00:00",
          "status": 1
        }]
      }
    },
    goLogin(val) {
      this.selectLoginType = val;
      this.loginShow = true;
    },
    initStyle(){
      let scaleNum = getScaleNum();
      document.documentElement.style.setProperty("--scale", scaleNum);

      this.homeFour1MansionInfoStyle = {
        top: `${-45*scaleNum}px`,
      }
      this.homeFour2MansionInfoStyle = {
        top: `${-64*scaleNum}px`,
        left: `${265*scaleNum}px`,
      }
      this.homeFour3MansionInfoStyle = {
        top: `${-82*scaleNum}px`,
      }
      this.homeFour4MansionInfoStyle = {
        top: `${-46*scaleNum}px`,
        left: `${235*scaleNum}px`,
      }

      this.homeFourStyle = {
        backgroundSize:`${1920*scaleNum}px ${1080*scaleNum}px`,
        width:`${1920*scaleNum}px`,
        height:`${1080*scaleNum}px`,

      }

      let homeFour2Polygon = " 0px 20px, 97px 0px, 202px 1px, 301px 8px, 465px 38px, 511px 54px, 501px 208px, 414px 251px, 334px 236px, 259px 198px, 171px 187px, 5px 176px";
      this.homeFour2ConStyle = {
        top:`${339*scaleNum}px`,
        left:`${722*scaleNum}px`,
        width:`${499*scaleNum}px`,
        height:`${233*scaleNum}px`,
      }
      this.homeFour2Style = {
        clipPath:`polygon(${getPolygon(homeFour2Polygon, scaleNum)})`,
      }

      let homeFour1Polygon = " 0px 16px, 76px 0px, 134px 4px, 191px 16px, 241px 27px, 295px 32px, 363px 29px, 443px 30px, 487px 33px, 516px 55px, 527px 72px, 530px 77px, 490px 402px, 450px 420px, 335px 425px, 212px 424px, 85px 382px, 71px 370px, 71px 288px, 0px 261px";
      this.homeFour1ConStyle = {
        top:`${383*scaleNum}px`,
        left:`${1204*scaleNum}px`,
        width:`${517*scaleNum}px`,
        height:`${413*scaleNum}px`,
      }
      this.homeFour1Style = {
        clipPath:`polygon(${getPolygon(homeFour1Polygon, scaleNum)})`,
      }

      let homeFour3Polygon = " 0px 21px, 78px 0px, 200px 0px, 339px 4px, 419px 21px, 443px 42px, 446px 102px, 447px 142px, 444px 150px, 420px 173px, 366px 181px, 261px 169px, 234px 145px, 45px 141px, 5px 122px";
      this.homeFour3ConStyle = {
        top:`${310*scaleNum}px`,
        left:`${276*scaleNum}px`,
        width:`${435*scaleNum}px`,
        height:`${170*scaleNum}px`,
      }
      this.homeFour3Style = {
        clipPath:`polygon(${getPolygon(homeFour3Polygon, scaleNum)})`,
      }

      let homeFour4Polygon = " 0px 82px, 115px 0px, 329px 0px, 324px 7px, 323px 10px, 441px 26px, 442px 58px, 430px 68px, 428px 91px, 430px 156px, 424px 172px, 361px 242px, 324px 258px, 236px 244px, 79px 231px, 0px 216px";
      this.homeFour4ConStyle = {
        top:`${577*scaleNum}px`,
        left:`${475*scaleNum}px`,
        width:`${435*scaleNum}px`,
        height:`${239*scaleNum}px`,
      }
      this.homeFour4Style = {
        clipPath:`polygon(${getPolygon(homeFour4Polygon, scaleNum)})`,
      }

    },
    goMansion(type, roleString) {
      const status = this.system_role.find(item => item.system == roleString).status
      if (status == 0) {
        return this.$message.error('该系统暂无权限，需要开通请让医院管理员联系医考帮客服人员')
      }
      if (status == 2) {
        return this.$message.error('该系统已到期，需要开通请让医院管理员联系医考帮客服人员')
      }
      if (type == 1) {
        this.$router.push('/home/examinationList')
      } else {
        shengyuRegisterOrLogin({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        }).then(res => {
          if (res.data.code == 200) {
            let pathUrl= ''
            if(type == 2){
              pathUrl= window.location.origin.includes('ykb-online-exam-test') ? 'https://ykb.medmeta.com/training?code='+ res.data.data : 'https://www.medmeta.com/training?code=' + res.data.data
            }else if(type == 3){
              pathUrl= window.location.origin.includes('ykb-online-exam-test') ? 'https://ykb.medmeta.com/skill?code='+ res.data.data : 'https://www.medmeta.com/skill?code=' + res.data.data
            }else if(type == 4){
              pathUrl= window.location.origin.includes('ykb-online-exam-test') ? 'https://ykb.medmeta.com/exam/exam?code='+ res.data.data : 'https://www.medmeta.com/exam/exam?code=' + res.data.data
            }
            this.$router.push({
              path: '/syIframe',
              query: {
                path:pathUrl
                // path: type == 2 ? 'https://www.medmeta.com/training?code=' + res.data.data : 'https://www.medmeta.com/skill?code=' + res.data.data
                // path: type == 2 ? 'https://www.medmeta.com/ykbtraining?code=' + res.data.data : 'https://www.medmeta.com/ykbskill?code=' + res.data.data
                
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    async switchHospital() {
      // 切换医院
      const res = await userHospital({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      });
      if (res.code === 200) {
        this.hospitalData = res.data;
        this.showHospital = true;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:root{
    --scale:1,
}

$scale:var(--scale, 1);
  @import "../../styles/home.scss";

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
    overflow: hidden;
  }
  .tools {
      position: fixed;
      top: calc(#{$scale} * 40px);
      right: calc(#{$scale} * 302px);
      display: flex;
      width: calc(#{$scale} * 95px);
      height: calc(#{$scale} * 55px);
      border-radius: calc(#{$scale} * 10px);;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgba(0,0,0,0.5);

      &:hover {
        background-color: rgba(0,0,0,0.8);
        div {
          background-image: url("../../assets/img/new-switch-hover.png");
        }
        .toolsText{
          color: #F5BC41;
        }
      }

      div {
        width: calc(#{$scale} * 30px);
        height: calc(#{$scale} * 30px);
        background: url("../../assets/img/new-switch.png");
        background-size: calc(#{$scale} * 30px) calc(#{$scale} * 30px);
        margin-right: 6px;
      }
      .toolsText{
        font-family: PingFangSC, PingFang SC;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
      }

    }
    .homeFour{
    width:1920px;
    height:1080px;
    background-image: url("../../assets/img/homeFour.png");
    background-repeat: no-repeat;
    background-size:cover;
    position: relative;
    .homeFour1Con,.homeFour2Con,.homeFour3Con,.homeFour4Con{
      position:absolute;
      cursor: pointer;
      .homeFour1,.homeFour2,.homeFour3,.homeFour4{
        width:100%;
        height:100%;
        .homeFour1Clip,.homeFour2Clip,.homeFour3Clip,.homeFour4Clip{
          width:100%;
          height:100%;
          background-repeat: no-repeat;
          background-size:cover;
        }

      }
    }
    .homeFour2Con{
      // top:339px;
      // left:722px;
      // width:499px;
      // height:233px;
      .homeFour2{
        clip-path:polygon(0px 20px, 97px 0px, 202px 1px, 301px 8px, 465px 38px, 511px 54px, 501px 208px, 414px 251px, 334px 236px, 259px 198px, 171px 187px, 5px 176px);
        .homeFour2Clip:hover{
          background-image: url("../../assets/img/homeFour2.png");
          // background-color:rgba(0,0,0,0.5);
        }
      }
    }
    .homeFour1Con{
      top:383px;
      left:1204px;
      width:517px;
      height:413px;
      .homeFour1{
        clip-path: polygon(0px 16px, 76px 0px, 134px 4px, 191px 16px, 241px 27px, 295px 32px, 363px 29px, 443px 30px, 487px 33px, 516px 55px, 527px 72px, 530px 77px, 490px 402px, 450px 420px, 335px 425px, 212px 424px, 85px 382px, 71px 370px, 71px 288px, 0px 261px);
        .homeFour1Clip:hover{
          background-image: url("../../assets/img/homeFour1.png");
          // background-color:rgba(0,0,0,0.5);
        }
      }
    }
    .homeFour3Con{
      top:310px;
      left:276px;
      width:435px;
      height:170px;
      .homeFour3{
        clip-path: polygon(0px 21px, 78px 0px, 200px 0px, 339px 4px, 419px 21px, 443px 42px, 446px 102px, 447px 142px, 444px 150px, 420px 173px, 366px 181px, 261px 169px, 234px 145px, 45px 141px, 5px 122px);
        .homeFour3Clip:hover{
          background-image: url("../../assets/img/homeFour3.png");
          // background-color:rgba(0,0,0,0.5);
        }
      }
    }

    .homeFour4Con{
      top:577px;
      left:475px;
      width:435px;
      height:239px;
      .homeFour4{
        clip-path: polygon(0px 82px, 115px 0px, 329px 0px, 324px 7px, 323px 10px, 441px 26px, 442px 58px, 430px 68px, 428px 91px, 430px 156px, 424px 172px, 361px 242px, 324px 258px, 236px 244px, 79px 231px, 0px 216px);
        .homeFour4Clip:hover{
          background-image: url("../../assets/img/homeFour4.png");
          // background-color:rgba(0,0,0,0.5);
        }
      }
    }
  }
  </style>

